// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"styles_footerContainer__19Ovw","logo":"styles_logo__GmwcT"};